import React, { Fragment, useState } from 'react';
import ChoicePanel from './ChoicePanel';
import SelectedPanel from './selectedPanel';
import { imageSet } from '../../../helper/Images';
import './question.scss';
import { quizItem } from '../../../../configuration/Quiz';

const Quiz = ({ onFinish }) => {
  const [questionIndex, setquestionIndex] = useState(0);
  const [answers, setAnswers] = useState(() => quizItem.map(() => -1));

  const handleNextClick = () => {
    if (questionIndex >= quizItem.length - 1) {
      onFinish(answers);
      return;
    }
    setquestionIndex(questionIndex + 1);
  };

  const handleSelect = (i) => {
    setAnswers((prevState) => {
      const items = [...prevState];
      items.splice(questionIndex, 1, i);
      return items;
    });
  };

  return (
    <div className="quiz-items">
      {quizItem.map((item, index) => {
        const { color, id, defaultMessage, className } = item;
        const answer = answers[questionIndex];
        const answerGiven = answer !== -1;
        const isSelected = questionIndex === index;
        const selectedSkinImage = answerGiven
          ? imageSet[color[answer]['square']]
          : '';
        return (
          isSelected && (
            <Fragment key={`${index}-${+isSelected}`}>
              <div className="quiz-item quiz-item__colors">
                <ChoicePanel
                  color={color}
                  handleSelect={handleSelect}
                  id={id}
                  defaultMessage={defaultMessage}
                />
              </div>
              <div className="quiz-item quiz-item__selected">
                <SelectedPanel
                  className={className}
                  btnDisabled={!answerGiven}
                  onButtonClick={handleNextClick}
                  displaySelection={answerGiven}
                  image={selectedSkinImage}
                />
              </div>
            </Fragment>
          )
        );
      })}
    </div>
  );
};

export default Quiz;
